export const UPDATE_CANDIDATE_PARTICULAR = '/candidates';
export const GET_CANDIDATE_PARTICULAR = '/candidates';
